import type { ApiConfig } from '#types/config/api'

export default {
  // this config is needed in order to match the APIs cookie name
  brandPrefix: 'VANS',
  // used to override CMS site ID, raw brand name is used by default
  cmsSiteId: 'canvas-vans'
} as ApiConfig
